'use client';

import { attemptSilentAuthOrLogin } from '@modules/auth/components/AuthGuard/AuthGuard';
import { useCommonAuthProvider } from '@modules/auth/providers/CommonAuthProvider/CommonAuthProvider';
import { useFlagsProxy } from '@modules/feature-flags/hooks/useFlagsProxy';
import { markAppEntry } from '@modules/shared/analytics/scripts/fullstoryUtils';
import { CustomSpin } from '@modules/shared/components/CustomSpin';

import { Route } from 'next';
import { useRouter } from 'next/navigation';
import React, { useEffect } from 'react';

const IndexPage: React.FC = () => {
  const { login, loginWithRedirect, isLoading, isAuthenticated } = useCommonAuthProvider();
  const { cloudMspEnableUiFeatures } = useFlagsProxy();
  const router = useRouter();

  useEffect(() => {
    if (isLoading) {
      return;
    }

    markAppEntry(isAuthenticated);
  }, [isLoading, isAuthenticated]);

  useEffect(() => {
    if (isLoading) {
      return;
    }

    if (isAuthenticated) {
      router.push('/organizations' as Route);

      return;
    }

    // The bare app root is the cross-app SSO landing target (e.g. Leader → Maestro
    // for a user with no product access). Attempt silent prompt=none auth before
    // interactive login so an active Auth0 session resolves to /organizations
    // instead of the login form — the same behavior the Auth0 SDK's checkSession()
    // gave us before its removal.
    attemptSilentAuthOrLogin({ login, loginWithRedirect, cloudMspEnableUiFeatures });
  }, [isLoading, isAuthenticated, router, login, loginWithRedirect, cloudMspEnableUiFeatures]);

  return <CustomSpin />;
};

export default IndexPage;
